export default __webpack_public_path__ + "static/media/right-arrow-fill.8b334773.svg";